import { gql, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { emtSocket } from "../../../../CommonFunction/SocketClient";
import AwardedAcceptedModal from "../../../Components/BookingComponents/AllModals/AwardedAcceptedModal/AwardedAcceptedModal";
import CnfModal from "../../../Components/BookingComponents/AllModals/CnfModal/CnfModal";
import FormattedTime from "../../../Components/BookingComponents/FormattedTime/FormattedTime";
import Button from "../../../Components/Button/Button";
import Table from "../../../Components/LpComponents/Table/Table";
import TBody from "../../../Components/LpComponents/Table/TableComponents/TBody/TBody";
import TD from "../../../Components/LpComponents/Table/TableComponents/TD/TD";
import TH from "../../../Components/LpComponents/Table/TableComponents/TH/TH";
import THead from "../../../Components/LpComponents/Table/TableComponents/THead/THead";
import TR from "../../../Components/LpComponents/Table/TableComponents/TR/TR";
// import Reactportal from "../../../Components/SpComponents/Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../../Components/ToastComponent/RectHotToast";
import Reactportal from "../../../Components/Reactportal/Reactportal";

export const EDIT_Trip_BookingS_DATA = gql`
  mutation EditTripBookings($editTripBookingsId: ID!, $userInput: TripBookingsInput!) {
    editTripBookings(id: $editTripBookingsId, userInput: $userInput) {
      id
      BidId
      UserId
      LoadId
      Unique_Id
      Vehicle_Number {
        _id
        Unique_Id
        UserId
        Vehicle_No
        createdAt
        updatedAt
      }
      Vehicle_Capacity
      Driver_Name
      POD_Collected_From_SP
      POD_Submitted_To_LP
      Freight_Amount
      Platform_Charges
      Current_Stage
      Driver_Number
      Reporting_Time
      Is_Confirmed
      Is_Accepted
      Is_Rejected
      TripBooking_Confirmed
      TripBooking_Confirmed_Time
      Vehicle_Reached_At_Loading_Point
      Vehicle_Reached_At_Loading_Point_Time
      Loading_Completed
      Loading_Completed_Time
      Advance_Processed
      Advance_Processed_Time
      Vehicle_Reach_At_Unloading_Point
      Vehicle_Reach_At_Unloading_Point_Time
      Unloading_Completed
      Unloading_Completed_Time
      Clear_Delivery_Confirmation
      Clear_Delivery_Confirmation_Time
      POD_Collected_From_SP_Time
      POD_Submitted_To_LP_Time
      Invoice_Number
      Eway_Bill_Number
      Eway_Bill_Created_Date
      Eway_Bill_Validate_Date
      Vehicle_Front_Img
      Vehicle_Back_Img
      Vehicle_Right_Img
      Vehicle_Left_Img
      Material_Img
      Entry_Gate_Img
      POD_Front_Copy
      POD_Back_Copy
      Invoice_Copy
      Final_Invoice_Copy
      Holding_Charges
      Hamali_Charges
      Extra_Running
      Challan_Demand
      Other_Charges
      Other_Charges_Reason
      Narration
      Sp_Claim_Raised
      Lp_Claim_Raised
      Sp_Claim_Cleared
      Lp_Claim_Cleared
      createdAt
      updatedAt
    }
  }
`;

function ResultTable({ awardedData, HandleRefetch, loadId, LPUserId, details, userDetails, i }) {
  // const spAccountBalanceID = sessionStorage.getItem("AccountBalanceId");
  const [awardedAcceptModal, setAwardedAcceptModal] = useState(false);
  const [cnfModal, setCnfModal] = useState(false);
  const [ID, setID] = useState("");

  const [isEditCommittedVehiclesLoading, setIsEditCommittedVehiclesLoading] = useState(false);
  const [
    editCommittedVehicles,
    { loading: editCommittedVehiclesLoading, data: editCommittedVehiclesData, error: editCommittedVehiclesError },
  ] = useMutation(EDIT_Trip_BookingS_DATA, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    setIsEditCommittedVehiclesLoading(editCommittedVehiclesLoading);
  }, [editCommittedVehiclesLoading]);

  useEffect(() => {
    if (editCommittedVehiclesError) {
      ErrorToast(editCommittedVehiclesError.message);
    }
  }, [editCommittedVehiclesError]);

  useEffect(() => {
    if (editCommittedVehiclesData) {
      // emtSocket.emit("EditConfirmVechileswithId", loadId);
      SuccessToast("Awarded Vehicle Rejected Successfully");
      setCnfModal(false);
      HandleRefetch();
    }
  }, [editCommittedVehiclesData]);

  async function rejectAwardedVehicle(id) {
    await editCommittedVehicles({
      variables: {
        editCommittedVehiclesId: id,
        userInput: {
          Is_Rejected: true,
          Is_Accepted: false,
        },
      },
    });
  }

  if (awardedData?.length === 0) {
    return <>No Bid Placed</>;
  }

  return (
    // <div>
    <Table>
      {i === 0 && (
        <THead>
          <TR>
            {/* <TH>Sr. No</TH> */}
            <TH>Business Name</TH>
            <TH>Proprietor Name</TH>
            <TH>Mobile No</TH>
            <TH>Bid Price</TH>
            <TH>Rank</TH>
            <TH>Bid Note</TH>
            <TH>Status</TH>
            <TH>Action</TH>
            <TH>Booking Id</TH>
            <TH>Vehicle No</TH>
            <TH>Driver Details</TH>
            <TH>Reporting Time</TH>
          </TR>
        </THead>
      )}

      <TBody>
        {awardedData?.map((el, i) => (
          <TR key={el.Unique_Id}>
            <TD>{userDetails?.FullName}</TD>
            <TD>{userDetails?.Company_Name}</TD>
            <TD>{userDetails?.mobileNumber}</TD>
            <TD>{details.Price}</TD>
            <TD>{details.Rank}</TD>
            <TD>{details.Bid_Note}</TD>
            <TD>
              <p className={el?.Is_Confirmed ? "awardedStatusText" : "pendingStatusText"}>
                {el?.Is_Confirmed ? "Awarded" : "Pending"}
                {el?.Is_Accepted ? "- Accepted" : ""}
                {el?.Is_Rejected ? (
                  <>
                    -{" "}
                    <p className="rejectedStatusText" style={{ marginBlockStart: "0em" }}>
                      Rejected
                    </p>
                  </>
                ) : (
                  ""
                )}
              </p>
            </TD>

            <TD>
              {el.Is_Confirmed ? (
                <div className="awardedBnDiv btn">
                  {el.Is_Accepted ? (
                    "-"
                  ) : el.Is_Rejected ? (
                    ""
                  ) : (
                    <div>
                      <Button
                        text="Accept"
                        name="modalbutton"
                        className="acptBtn"
                        action={() => {
                          setAwardedAcceptModal(true);
                          setID(el._id);
                        }}
                      />
                    </div>
                  )}

                  {el?.Is_Rejected ? (
                    "-"
                  ) : el?.Is_Accepted ? (
                    ""
                  ) : (
                    <div>
                      <Button
                        text="Reject"
                        name="modalbutton"
                        className="rejBtn"
                        action={() => {
                          setCnfModal(true);
                          setID(el._id);
                        }}
                      />
                    </div>
                  )}
                </div>
              ) : (
                ""
              )}
            </TD>
            <TD>{el?.Is_Accepted ? el?.Unique_Id : "-"}</TD>
            <TD>{el?.Vehicle_Number && el?.Vehicle_Number[0]?.Vehicle_No}</TD>
            <TD>{el.Driver_Name ? `${el?.Driver_Name} - ${el?.Driver_Number}` : "-"}</TD>
            <TD>{el?.Reporting_Time ? <FormattedTime time={el?.Reporting_Time} /> : "-"}</TD>
          </TR>
        ))}
        <Reactportal
          open={awardedAcceptModal}
          modalHeading="Vehicle Confirmation"
          onClose={() => setAwardedAcceptModal(false)}
          modalClassName={"VehicleCnfModal"}
          contentClassName={"VehicleCnfModal-content"}
        >
          <AwardedAcceptedModal
            ID={ID}
            loadId={loadId}
            SpId={awardedData[0].UserId}
            Vehicle_No={awardedData[0].Vehicle_Number[0]}
            onClose={() => {
              setAwardedAcceptModal(false);
            }}
            RefetchUpdated={() => HandleRefetch()}
          />
        </Reactportal>
        <Reactportal
          open={cnfModal}
          modalHeading="Confirmation"
          modalClassName="confirmationModal"
          contentClassName="confirmationModal-content"
          onClose={() => setCnfModal(false)}
        >
          <CnfModal
            onClose={() => setCnfModal(false)}
            cnfMessage={
              "Do you want to reject these awarded vehicles? (If you reject this awarded vehicle penalty of ₹ 500 will deduct from your account)"
            }
            editCommittedVehiclesData={() => {
              rejectAwardedVehicle(ID);
            }}
            loading={isEditCommittedVehiclesLoading}
          />
        </Reactportal>
      </TBody>
    </Table>
    // </div>
  );
}

export default ResultTable;
